import { buildTennisLiveMobileProps } from "../buildTennisLiveMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildTennisLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildTennisLiveMobileProps(event, config)), { backgroundImage: getTennisBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
function getTennisBackgroundImage(event, defaultScoreboardImages) {
    const images = defaultScoreboardImages[`${event.sportId}_${event.tennisSurface}`];
    if (images) {
        return event.isLive ? images.liveImage : images.preLiveImage;
    }
    return getBackgroundImage(event, defaultScoreboardImages);
}
//# sourceMappingURL=buildTennisLiveDesktopProps.js.map